__turbopack_context__.v({
  "authButtons": "navigation-bar-module__D8ADAG__authButtons",
  "container": "navigation-bar-module__D8ADAG__container",
  "divider": "navigation-bar-module__D8ADAG__divider",
  "headerButtons": "navigation-bar-module__D8ADAG__headerButtons",
  "linksWrapper": "navigation-bar-module__D8ADAG__linksWrapper",
  "logo": "navigation-bar-module__D8ADAG__logo",
  "logoWrapper": "navigation-bar-module__D8ADAG__logoWrapper",
  "menuDrawer": "navigation-bar-module__D8ADAG__menuDrawer",
  "menuDrawerWrapper": "navigation-bar-module__D8ADAG__menuDrawerWrapper",
  "ozone": "navigation-bar-module__D8ADAG__ozone",
  "profileSection": "navigation-bar-module__D8ADAG__profileSection",
  "root": "navigation-bar-module__D8ADAG__root",
  "signInButton": "navigation-bar-module__D8ADAG__signInButton",
  "signUpButton": "navigation-bar-module__D8ADAG__signUpButton",
  "textLogo": "navigation-bar-module__D8ADAG__textLogo",
});
